import { HeaderContext } from "@tanstack/react-table";
import { BreakableText } from "@design-system/BreakableText/BreakableText";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { useViewTableMeta } from "@hooks/view/useViewTableMeta";
import { PlusIcon } from "@icons";
import { RequiredAccountRow } from "../requiredAccountsMapping";
import styles from "../RequiredAccountsMapping.module.scss";
import {
    RequiredAccountsCallbacks,
    RequiredAccountsOptions,
} from "./RequiredAccountAssignedCell";

const CREATE_DEFAULT_ACCOUNTS_LABEL = "Create default accounts";

export const RequiredAccountNameHeaderCell = ({
    column,
    table,
}: HeaderContext<ViewTableFeatures, RequiredAccountRow, unknown>) => {
    const { callbacks, options } = useViewTableMeta<
        RequiredAccountsCallbacks,
        RequiredAccountsOptions
    >(table);

    return (
        <HStack
            gap={8}
            align="center"
            justify="between"
            className={styles.requiredAccountHeader}
        >
            <BreakableText
                text={column.columnDef.meta?.headerLabel ?? ""}
                showTooltip
                className={styles.requiredAccountHeaderText}
            />
            {options?.hasDefaultAccountsToCreate && (
                <Tooltip content={CREATE_DEFAULT_ACCOUNTS_LABEL}>
                    <Button
                        variant="secondary"
                        size="sm"
                        iconOnly
                        aria-label={CREATE_DEFAULT_ACCOUNTS_LABEL}
                        disabled={options?.isCreateDefaultAccountsDisabled}
                        onClick={() => callbacks?.onCreateDefaultAccounts()}
                    >
                        <PlusIcon />
                    </Button>
                </Tooltip>
            )}
        </HStack>
    );
};
